import { render } from "./SideBar.vue?vue&type=template&id=df3dfcda&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=df3dfcda&lang=css"
import "./SideBar.vue?vue&type=style&index=1&id=df3dfcda&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df3dfcda"]])

export default __exports__